<template>
  <div>
    <div class="checkbox-wrapper modal-register-newsletter">
      <div class="checkbox">
        <input name="newsletter" type="checkbox" v-model="model" id="register-newsletter"/>
        <label for="register-newsletter">Даю <a target="_blank" href="https://exporteduru.servicecdn.ru/media/default/0003/49/cbc5831f56904069c2948e6fe7f852b584bd1fcb.pdf">Согласие на получение рекламных рассылок</a></label>
      </div>
    </div>
  </div>
</template>

<script>
import vmMixin from "@/mixins/vmMixin";

export default {
  name: "RegistrationConfirmEmail",
  mixins: [vmMixin],
}
</script>

<style scoped>

</style>